/**
 * useAccessibility — composable de acesso ao store de acessibilidade.
 *
 * P-UX-04 (Accessibility first): a API é minimalista e direta;
 * qualquer componente pode ler/gravar preferências sem fricção.
 */
import { storeToRefs } from "pinia";
import { useAccessibilityStore } from "../store";
import type { AccessibilityPreferences } from "../types";

export function useAccessibility() {
  const store = useAccessibilityStore();
  const { preferences } = storeToRefs(store);
  return {
    preferences,
    setPreferences: (next: Partial<AccessibilityPreferences>) =>
      store.setPreferences(next),
    resetToDefaults: () => store.resetToDefaults(),
    init: () => store.init(),
  };
}
